var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoyaltyPerk1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#loyalty-perk-1_svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#719C89",
  fillRule: "evenodd",
  d: "M10.607 10.05v-.004c0-.252.202-.455.452-.455h5.862v-.003c2.437-.06 4.396-2.07 4.396-4.542S19.358.564 16.921.503V.5H7c0 1.998 1.6 3.621 3.58 3.636h4.537c.498 0 .902.407.902.909s-.404.908-.902.908v.002h-4.509v.026c-2.03.226-3.607 1.96-3.607 4.065v.004z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#80A388",
  d: "M21.443 9.846H7V32.5h14.443z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "loyalty-perk-1_svg__b",
  width: 19,
  height: 23,
  x: 7,
  y: 10,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.408 10.002H7V32.5h18.408z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#2C5234",
  mask: "url(#loyalty-perk-1_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.317 10.002H7v2.125h14.317zm0 4.73v-1.923H7V29.69h14.317v-3.393a6.145 6.145 0 0 0 4.09-5.783 6.14 6.14 0 0 0-4.09-5.784m0 9.321v-7.077a4.081 4.081 0 0 1 0 7.077m0 6.32H7V32.5h14.317z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "loyalty-perk-1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export default SvgLoyaltyPerk1;